import { render, staticRenderFns } from "./LessonTypeAdmin.vue?vue&type=template&id=25547f2e&scoped=true&"
import script from "./LessonTypeAdmin.vue?vue&type=script&lang=js&"
export * from "./LessonTypeAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25547f2e",
  null
  
)

export default component.exports